import { createApi } from '@reduxjs/toolkit/dist/query/react/index.js';
import axiosBaseQuery from '../../services/customQuery';
export const api = createApi({
    reducerPath: 'api',
    baseQuery: axiosBaseQuery(),
    endpoints: () => ({}),
    tagTypes: ['Faq'],
});
